import { GroupedChoiceList } from 'types/Question';

export const prepareUserAreas = (groupedAreas: GroupedChoiceList[]) =>
	groupedAreas
		? (groupedAreas || [])?.reduce(
				(prevValue, curValue) => [...prevValue, ...(curValue?.options || [])],
				[] as string[]
		  )
		: [];
